import { useState } from "react";
import { AttributeAPI } from "@griffingroupglobal/eslib-api";

const useCheckDuplicateAttribute = () => {
  const [isDuplicate, setIsDuplicate] = useState(false);

  const checkDuplicateAttribute = async (detail) => {
    if (!detail) return null;

    try {
      const extras = {
        params: {
          detail,
        },
      };
      const { response } = await AttributeAPI.getWOP("$lookup", extras);
      const entries = response?.data?.entries || [];
      setIsDuplicate(true);
      return entries;
    } catch (error) {
      setIsDuplicate(false);
      return { statusCode: error.status, errorMessage: error.message };
    }
  };

  return {
    checkDuplicateAttribute,
    isDuplicate,
    setIsDuplicate,
  };
};

export default useCheckDuplicateAttribute;
